import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Data, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { FeatureFlagsService } from '../feature-flags/feature-flags-service';
import { RouteMetadata } from './route-meta-data';

interface FeatureFlagRouteData extends Data, RouteMetadata {
  redirectTo?: string;
}
interface FeatureFlagRouteSnapshot extends ActivatedRouteSnapshot {
  data: FeatureFlagRouteData;
}

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagGuard implements CanActivate {
  constructor(
    private readonly featureFlagsService: FeatureFlagsService,
    private readonly router: Router
  ) {}

  canActivate(next: FeatureFlagRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const { featureName, redirectTo } = next.data;
    if (!featureName) {
      return of(true);
    }

    return this.featureFlagsService.isEnabled$(featureName).pipe(
      take(1),
      map(enabled => enabled || this.router.parseUrl(redirectTo || '/'))
    );
  }
}
